import { Button, Group, Stack, Tabs, Textarea, TextInput } from '@mantine/core';
import { useForm } from '@mantine/form';
import { useState } from 'react';

interface TranslationCreateFormProps {
	onSubmit: (values: any) => void;
	onCancel: () => void;
	loading?: boolean;
}

export function TranslationCreateForm({ onSubmit, onCancel, loading }: TranslationCreateFormProps) {
	const [activeTab, setActiveTab] = useState<string>('en');

	const form = useForm({
		initialValues: {
			key: '',
			en: '',
			da: '',
		},
		validate: {
			key: (value) => (!value ? 'Translation key is required' : null),
			en: (value) => (!value ? 'English translation is required' : null),
			da: (value) => (!value ? 'Danish translation is required' : null),
		},
	});

	const handleSubmit = (values: any) => {
		onSubmit({
			key: values.key,
			translations: [
				{ language: 'en', content: values.en },
				{ language: 'da', content: values.da },
			],
		});
	};

	return (
		<form onSubmit={form.onSubmit(handleSubmit)}>
			<Stack gap="md">
				<TextInput
					label="Translation Key"
					placeholder="e.g. app.units.year"
					required
					{...form.getInputProps('key')}
				/>

				<Tabs value={activeTab} onChange={(value) => setActiveTab(value || 'en')}>
					<Tabs.List>
						<Tabs.Tab value="en">English</Tabs.Tab>
						<Tabs.Tab value="da">Danish</Tabs.Tab>
					</Tabs.List>

					<Tabs.Panel value="en" pt="md">
						<Textarea
							label="English Translation"
							placeholder="Enter English translation"
							required
							autosize
							minRows={3}
							maxRows={10}
							{...form.getInputProps('en')}
						/>
					</Tabs.Panel>

					<Tabs.Panel value="da" pt="md">
						<Textarea
							label="Danish Translation"
							placeholder="Enter Danish translation"
							required
							autosize
							minRows={3}
							maxRows={10}
							{...form.getInputProps('da')}
						/>
					</Tabs.Panel>
				</Tabs>

				<Group justify="flex-end" mt="md">
					<Button variant="subtle" onClick={onCancel} disabled={loading}>
						Cancel
					</Button>
					<Button type="submit" loading={loading}>
						Create Translation
					</Button>
				</Group>
			</Stack>
		</form>
	);
}
